export enum SystemStatus {
  ACTIVE = 'active',
  MAINTENANCE = 'maintenance',
}

export const systemStatuses = () => {
  return Object.keys(SystemStatus).map((status) => SystemStatus[status]);
};
